import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "ListBlock-root_dU7ih"
};
export function ListBlock({
  children,
  className
}) {
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles.root, className),
    children: children
  });
}